import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { DataService } from '../services/data.service';
import { UrlConstants } from '../services/url-constants';
import { ConstantsService } from '../services/constants.service';
import { Location } from '@angular/common';

@Component({
  selector: 'app-gaze-policy',
  templateUrl: './gaze-policy.component.html',
  styleUrls: ['./gaze-policy.component.scss']
})
export class GazePolicyComponent implements OnInit {
  safeHtmlContent!: SafeHtml;
  isLoaderActive: boolean = false;
  policyType: 'terms' | 'privacy' = 'terms';

  get pageTitle(): string {
    return this.policyType === 'privacy' ? 'Privacy Policy' : 'Terms of Service';
  }

  constructor(
    private sanitizer: DomSanitizer,
    private dataService: DataService,
    private urlConstants: UrlConstants,
    private route: ActivatedRoute,
    private router: Router,
    public constants: ConstantsService,
    private location: Location
  ) {}

  ngOnInit() {
    this.route.data.subscribe(data => {
      this.policyType = data['type'] || 'terms';
      this.getPolicyContent();
    });
  }

  private async getPolicyContent() {
    const postParams = [
      { param: '{actionName}', value: 'getGazePolicy' }
    ];

    try {
      this.isLoaderActive = true;

      const body = {
        policyType: this.policyType
      };

      this.dataService.postData(
        this.urlConstants.getUri(this.urlConstants.actionUnAuth, postParams),
        body
      ).subscribe({
        next: (response: any) => {
          this.isLoaderActive = false;
          if (response && response.Item && response.Item.htmlContent) {
            let content = response.Item.htmlContent;
            const title = this.policyType === 'privacy' ? 'Privacy Policy' : 'Terms & Conditions';
            
            if (!content.match(new RegExp(`<h[12][^>]*>\\s*${title}\\s*</h[12]>`, 'i'))) {
              content = `<h1>${title}</h1>` + content;
            }
            
            this.safeHtmlContent = this.sanitizer.bypassSecurityTrustHtml(content);
          } else {
            this.safeHtmlContent = this.sanitizer.bypassSecurityTrustHtml('<p>Failed to load policy. Please try again later.</p>');
          }
        },
        error: (error) => {
          this.isLoaderActive = false;
          console.error('Error fetching policy content from API:', error);
          this.safeHtmlContent = this.sanitizer.bypassSecurityTrustHtml('<p>Failed to load policy. Please try again later.</p>');
        }
      });
    } catch (error) {
      console.error('Error in getPolicyContent:', error);
      this.isLoaderActive = false;
      this.safeHtmlContent = this.sanitizer.bypassSecurityTrustHtml('<p>Failed to load policy. Please try again later.</p>');
    }
  }

  OnClickClose() {
    this.location.back();
  }
}
